import classNames from 'classnames';
import React from 'react';
import ReactImageMagnify from 'react-image-magnify';
import Modal, { ModalProps } from 'rsuite/lib/Modal';
import styles from './PhotoModal.module.scss';

const S3_REPOSITORY_URL = 'https://s3.amazonaws.com/infoprice-prd-repository';
const CLOUDFRONT_REPOSITORY_URL = 'https://d1kkb7tj44tam6.cloudfront.net';

export type PhotoModalProps = {
  photo?: null | string;
} & ModalProps;

export const PhotoModal = ({ className, photo, ...props }: PhotoModalProps) => {
  const normalizedPhoto = photo?.replace(S3_REPOSITORY_URL, CLOUDFRONT_REPOSITORY_URL);

  return (
    normalizedPhoto && (
      <Modal {...props} className={classNames(styles['photo-modal'], className)}>
        <Modal.Header />
        <Modal.Body className={styles['photo-modal__body']}>
          <ReactImageMagnify
            smallImage={{
              alt: 'Foto do produto',
              isFluidWidth: true,
              src: normalizedPhoto,
              height: 600,
            }}
            largeImage={{
              src: normalizedPhoto,
              width: 1200,
              height: 1080,
            }}
            enlargedImagePosition="over"
            hintTextMouse="Deslize o cursor para dar zoom"
            isHintEnabled
          />
        </Modal.Body>
        <button className="rs-modal-header-close" onClick={props.onHide}>
          <span>x</span>
        </button>
      </Modal>
    )
  );
};
